import { FrontendLoadLocation } from '@trucksmarter/shared';
import { toPluralized } from '../../../../../../../../../utils/pluralize';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';
import DallasStack from '~/app/_ui/Dallas/Stack/DallasStack';
import DallasSvgIconArrowRightAltOutlined from '@ui/Dallas/Icons/DallasSvgIconArrowRightAltOutlined';

const DEFAULT_STOP_COUNT = 2;

interface Props {
  stops: FrontendLoadLocation[];
}

export default function LoadTableTripArrowWithExtraStopCount({ stops }: Props) {
  const extraStopCount = stops.length - DEFAULT_STOP_COUNT;

  return (
    <DallasStack gap="none" alignVertical="center" alignHorizontal="center">
      <DallasSvgIconArrowRightAltOutlined color="darkGray" />
      {extraStopCount > 0 && (
        <DallasText variant="captionM" color="darkGray">
          +{extraStopCount} {toPluralized(extraStopCount, 'stop')}
        </DallasText>
      )}
    </DallasStack>
  );
}
